import { deleteApi, getApi, postApi, putApi } from "../../common/api";

export const listBlogs = (params: string = "") => {
    return getApi('/api/blogs', params);
};

export const getBlog = (id: string) => {
    return getApi('/api/blogs/' + id);
};

export const createBlog = (data: any) => {
    return postApi('/api/blogs', data);
};

export const updateBlog = (id: string, data: any) => {
    return putApi('/api/blogs/' + id, data);
};

export const deleteBlog = (id: string) => {
    return deleteApi('/api/blogs/' + id);
};

export const getFeaturedBlogs = (limit: number = 4) => {
    return getApi('/api/blogs/featured?limit=' + limit);
};

export const getRecentBlogs = (limit: number = 5) => {
    return getApi('/api/blogs/recent?limit=' + limit);
};

export const getBlogCategories = () => {
    return getApi('/api/blogs/categories');
};

export const getBlogsByCategory = (category: string, params: string = "") => {
    return getApi('/api/blogs/category/' + encodeURIComponent(category), params);
};

export const likeBlog = (id: string) => {
    return postApi('/api/blogs/' + id + '/like', {});
};

export default {
    listBlogs,
    getBlog,
    createBlog,
    updateBlog,
    deleteBlog,
    getFeaturedBlogs,
    getRecentBlogs,
    getBlogCategories,
    getBlogsByCategory,
    likeBlog
};
